export { Colors } from './Colors';
export { ColorsMove } from './MoveTheme';
export { ButtonColorSchema } from './ButtonColorSchema';
export { ButtonColorSchemaMove } from './ButtonColorSchemaMove';
export { AmenityIconsMap } from './AmenityIconsMap';
export { AmenityGrouping } from './AmenityGrouping';
export {
  CANCELLATION_REASONS,
  CANCELLATION_REFUND_TYPE,
  BOOKING_STATUS,
  BOOKING_PAY_AT_HOTEL_MAPPING,
  BOOKING_STATUS_COLOR,
  BOOKING_PENDING_STATUSES,
  CANCELLATION_PENALTY_TYPES,
  CANCELLATION_CHARGE_TYPES,
  BOOKING_MAPPING,
  BOOKING_CHECKOUT_KEY,
  DEFAULT_LAYOUT_STATUS,
  PAY_AT_HOTEL_ALLOW_STATUS,
  BOOKING_PAY_LATER_MAPPING,
} from './Booking';
export {
  CATEGORY,
  EVENT_TYPE,
  SORT_TYPE,
  getSortByOptions,
  GuestRatingOptions,
  getHotelClassOptions,
  AMENTITIES_FILTER_TYPE,
  getAmentitiesList,
  getPropertyTypesLocalised,
  getAmentitiesLocalised,
  getPaymentCancellationOptions,
  getSortByOptionsNew,
} from './SortAndFilter';
export { roomFilterOptions, roomFilterCategories } from './RoomFilters';
export {
  getPriceFilterOptions,
  getPriceFilterOptionsHotel,
  getPriceFilterOptionsConfing,
} from './PriceFilter';
export { UHF } from './UHF';
export {
  FILTER_TO_HOTEL_SEARCH_RESULTS,
  SNAP_CATEGORY,
  FLIGHT_CONNECTION_TYPE,
  FLIGHT_TYPE,
  TRIP_TYPE,
  BACK_FROM_HOTEL_LIST_LABEL,
  BACK_FROM_GUEST_DETAIL_LABEL,
  BACK_DEFAULT_TRACKING_LABEL,
  ROOM_BED_TYPE,
  BREAKFAST_PROVISION,
  WIFI_PROVISION,
  PAYMENT_METHOD_ECOMMERCE_GTM,
} from './Analytics';
export { REACT_NATIVE_WEBVIEW_SIGNAL } from './ReactNativeWebViewSignal';
export { TRIP_DETAIL } from './TripDetails';
export { FeatureFlags, HotelFeatureFlags } from './FeatureFlags';

export const EMPTY_FUNCTION = () => {};

export const THUMBNAIL_SIZE = '350px';
export const HERO_SIZE = '1000px';
export const HOTELS_LIST_BATCH_SIZE = 50;
export const ENABLE_SORTING_HOTEL_LIST_AT_CLIENT = true;
export const SNAP_TOKEN_NAME = 'snapToken';
export const NATIVE_LOGIN_STATE_NAME = 'isLoggedIn';
export const COUNTRY_CODE_HEADER = 'x-cdn-geo-country';
export const WMP_PAYMENT_URL = 'WMP_URL';

export {
  HTTP_CODE,
  CHECKOUT_STATUS_CODE,
  FLIGHT_STATUS_CODE,
} from './HttpCode';

export const FREE_CANCELLATION_TAG = 'free_cancellation';
export const ROOMS_LEFT_TAG = 'rooms_left';
export const BEST_PRICE_GUARANTEED_TAGS = 'best_price_guaranteed';
export const MEMBER_RATE = 'member_rate';
export const CRAZY_PRICE = 'crazy_price';

export const CHECKOUT_TIMEOUT = 'checkoutTimeout';
export const BIG_MEMBER_ID = 'big_member_id';
export const X_AUTH_HEADER = 'X-Auth';
export const TRIP_INFO_KEY = 'tripInfo';
export const REFRESH_TOKEN = 'Refresh-Token';

export { PAYMENT_METHOD, CHARGE_TYPE, DISCOUNT_METHOD } from './Payment';

export { ANDROID, IOS } from './Platform';

export { Currencies } from './Currencies';

export { TRIP_ADVISOR } from './TripAdvisor';

export { LOCATION_FILTER } from './LocationFilter';

export { AmenityRanking } from './AmenityRanking';

export const FILTER_TYPE_BANNER = {
  PROMOTION_FILTER: 'PROMOTION_FILTER',
  FLYER_DISCOUNT: 'FLYER_DISCOUNT',
  PROMOTION_DISCOUNT: 'PROMOTION_DISCOUNT',
};

export const BANNER_TYPE = {
  PROMO_BANNER: 'PROMO_BANNER',
  CROSS_SELL_BANNER: 'CROSS_SELL_BANNER',
  NOTIFICATION_BANNER: 'NOTIFICATION_BANNER',
  VOUCHER_BANNER: 'VOUCHER_BANNER',
  USER_SUBSCRIPTION_BANNER: 'USER_SUBSCRIPTION_BANNER',
  TOGGLE_BANNER: 'TOGGLE_BANNER',
};

export const FILTER_TYPE = {
  PROMOTION_FILTER: 'PROMOTION_FILTER',
  FLYER_DISCOUNT: 'FLYER_DISCOUNT',
  PROMOTION_DISCOUNT: 'PROMOTION_DISCOUNT',
};

export const BAGGAGE_TYPE = {
  HAND: 'hand',
  HOLD: 'hold',
  SPORTS: 'sportsEquipment',
};

export const BAGGAGE_DEFAULT_ID = {
  HAND: 'DEFAULT_HAND',
  HOLD: 'DEFAULT_HOLD',
  SPORTS: 'DEFAULT_SPORTS',
};
